import { format } from 'date-fns'
import { getLanguageLocalStorage } from '~/features/i18n/utils/languageLocalStorage'
import { getClientId } from '~/libs/ga'
import { NewMyProfileArgs, UpdateMyProfileArgs } from './type'

export function createNewMyProfileFormData(args: NewMyProfileArgs): FormData {
  const formData = new FormData()
  const localStorageLanguage = getLanguageLocalStorage()
  if (args.avatar !== undefined) {
    formData.append('avatar', args.avatar)
  }
  if (localStorageLanguage !== undefined) {
    formData.append('language', localStorageLanguage)
  }
  formData.append('name', args.name)
  formData.append('gender', args.gender)
  formData.append('date_of_birth', format(args.date_of_birth, 'yyyy-MM-dd'))
  const gaClientId = getClientId()
  if (gaClientId !== undefined) {
    formData.append('ga_client_id', gaClientId)
  }

  const utm = {
    medium: localStorage.getItem('utm_medium'),
    source: localStorage.getItem('utm_source'),
    campaign: localStorage.getItem('utm_campaign'),
    content: localStorage.getItem('utm_content'),
    term: localStorage.getItem('utm_term'),
  }

  if (utm.medium) {
    formData.append('utm_medium', utm.medium)
  }
  if (utm.source) {
    formData.append('utm_source', utm.source)
  }
  if (utm.campaign) {
    formData.append('utm_campaign', utm.campaign)
  }
  if (utm.content) {
    formData.append('utm_content', utm.content)
  }
  if (utm.term) {
    formData.append('utm_term', utm.term)
  }

  return formData
}

export function createUpdateMyProfileFormData(args: UpdateMyProfileArgs): FormData {
  const formData = new FormData()
  if (args.avatar !== undefined) {
    formData.append('avatar', args.avatar)
  }
  if (args.date_of_birth !== undefined) {
    formData.append('date_of_birth', format(args.date_of_birth, 'yyyy-MM-dd'))
  }
  formData.append('name', args.name)
  formData.append('gender', args.gender)
  formData.append('mail_desired', `${args.mail_desired}`)
  return formData
}
